"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var actionTypes_1 = __importDefault(require("../actionTypes"));
var SET_STATE = actionTypes_1.default.SET_STATE;
function default_1(originModels) {
    var models = {};
    Object.keys(originModels).forEach(function (name) {
        var model = originModels[name];
        if (!model.reducers) {
            model.reducers = {};
        }
        if (!model.reducers.setState) {
            model.reducers.setState = function (state, payload) { return (__assign(__assign({}, state), payload)); };
        }
        if (!model.reducers[SET_STATE]) {
            model.reducers[SET_STATE] = function (state, payload) { return payload; };
        }
        models[name] = model;
    });
    return models;
}
exports.default = default_1;
//# sourceMappingURL=appendReducers.js.map